<template>
  <NuxtLoadingIndicator :throttle="0" color="#751D2A" />
  <div class="h-screen grid grid-rows-[auto_1fr]">
    <Header />
    <NuxtPage />
  </div>
</template>
